// Dealer Status Check and Banner Management
(function() {
  'use strict';

  // Function to check dealer status and update banner visibility
  function checkDealerStatusAndUpdateBanner() {
    const customerData = document.getElementById('customer-data');
    if (customerData) {
      const isDealer = customerData.getAttribute('data-is-dealer') === 'true';
      const customerTags = JSON.parse(customerData.getAttribute('data-customer-tags') || '[]');
      
      if (isDealer || customerTags.includes('Dealer')) {
        // Hide banner for dealers
        const desktopBanner = document.getElementById('salesBannerDesktop');
        const mobileBanner = document.getElementById('mobileBanner');
        if (desktopBanner) desktopBanner.style.display = 'none';
        if (mobileBanner) mobileBanner.style.display = 'none';
      }
    }
  }

  // Function to refresh customer data by reloading the page
  function refreshCustomerData() {
    // Instead of calling a server endpoint, we'll reload the page
    // This ensures fresh customer data from Shopify
    if (document.visibilityState === 'visible') {
      // Only reload if the page has been inactive for more than 10 minutes
      const lastActivity = sessionStorage.getItem('lastActivity') || Date.now();
      const timeSinceLastActivity = Date.now() - lastActivity;
      
      if (timeSinceLastActivity > 10 * 60 * 1000) { // 10 minutes
        console.log('Refreshing page due to inactivity...');
        window.location.reload();
      }
    }
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    // Update last activity timestamp
    sessionStorage.setItem('lastActivity', Date.now());
    
    // Check immediately
    checkDealerStatusAndUpdateBanner();
    
    // Check again after a short delay to handle any delayed loading
    setTimeout(checkDealerStatusAndUpdateBanner, 1000);
    
    // Listen for customer data updates
    const customerData = document.getElementById('customer-data');
    if (customerData) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName.startsWith('data-')) {
            checkDealerStatusAndUpdateBanner();
          }
        });
      });
      
      observer.observe(customerData, { attributes: true });
    }

    // Update activity timestamp on user interaction
    ['click', 'scroll', 'keypress', 'mousemove'].forEach(eventType => {
      document.addEventListener(eventType, function() {
        sessionStorage.setItem('lastActivity', Date.now());
      }, { passive: true });
    });

    // Check for inactivity every 5 minutes
    setInterval(function() {
      const lastActivity = sessionStorage.getItem('lastActivity') || Date.now();
      const timeSinceLastActivity = Date.now() - lastActivity;
      
      // If inactive for more than 10 minutes, refresh customer data
      if (timeSinceLastActivity > 10 * 60 * 1000) {
        refreshCustomerData();
      }
    }, 5 * 60 * 1000);

    // Refresh when tab becomes visible
    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'visible') {
        // Update activity timestamp
        sessionStorage.setItem('lastActivity', Date.now());
        
        // Check if we need to refresh
        const lastActivity = sessionStorage.getItem('lastActivity') || Date.now();
        const timeSinceLastActivity = Date.now() - lastActivity;
        
        if (timeSinceLastActivity > 10 * 60 * 1000) {
          refreshCustomerData();
        }
      }
    });
  });

  // Export functions for global access
  window.DealerStatusCheck = {
    checkDealerStatusAndUpdateBanner: checkDealerStatusAndUpdateBanner,
    refreshCustomerData: refreshCustomerData
  };
})(); 